//#region import
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import {
  BtnAddOnTable,
  BtnEditOnTable,
  BtnViewOnTable,
} from "components/Button/ButtonTable";
import { GridColDef } from "@mui/x-data-grid-pro";
import { FormProvider, useForm } from "react-hook-form";
import { GetMenuPermission } from "utilities/SystemFunction";
import { SelectItem } from "components/Input/Select/SelectItem";
import { BtnClear, BtnSearch } from "components/Button/ButtonAll";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";

//#endregion

export default function SaveWorkingStatusList() {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const location = useLocation();

  const [loadingTable, setLoadingTable] = useState(false);
  const [arrName, setArrName] = useState([]);

  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
  });

  const [nPermission, setPermission] = useState<boolean>(true); // Permission

  const form = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
  });

  const dataColumn: GridColDef[] = [
    {
      field: "btnAction",
      headerName: "",
      align: "center",
      type: "actions",
      resizable: false,
      sortable: false,
      width: 60,
      renderHeader: (item) =>
        nPermission ? (
          <BtnAddOnTable
            onClick={() => navigate("/SaveWorkingStatusForm")}
            id={"btnAdd"}
          />
        ) : (
          <></>
        ),
      getActions: (item) => {
        return [
          nPermission ? (
            <BtnEditOnTable
              id="btnEdit"
              key={"btnEdit"}
              onClick={() => handleEdit(item.row.sID)}
            />
          ) : (
            <BtnViewOnTable
              id="btnEdit"
              key={"btnEdit"}
              onClick={() => handleEdit(item.row.sID)}
            />
          ),
        ];
      },
    },
    {
      field: "sUserName",
      headerName: `${I18n.SetText("TimeAttendance.sEmpName")}`,
      headerAlign: "center",
      align: "left",
      sortable: true,
      flex: 1,
      minWidth: 220,
    },
    {
      field: "sSaveBy",
      headerName: `${I18n.SetText("TimeAttendance.sSaveBy")}`,
      headerAlign: "center",
      align: "left",
      sortable: true,
      flex: 1,
      minWidth: 220,
    },
    {
      field: "sSaveDate",
      headerName: `${I18n.SetText("TimeAttendance.sSaveDate")}`,
      headerAlign: "center",
      align: "center",
      sortable: true,
      width: 220,
    },
  ];

  const handleEdit = (sID: string) => {
    navigate(`/SaveWorkingStatusForm?sID=${encodeURI(sID)}`);
  };

  const handleDelete = (e) => {
    DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmDel")}`, () => {
      AxiosFn.Post(
        `TimeAttendance/OnDeleteSaveStatus`,
        { lstID: e, sLocation: location.pathname },
        (result) => {
          if (result.nStatusCode === 200) {
            DialogFn.Success("ลบข้อมูลสำเร็จ");
            getTable(dataRow);
          }
        }
      );
    });
  };

  const getTable = (p: PaginationInterface) => {
    setLoadingTable(true);
    let objParam = {
      ...p,
      lstName: form.getValues("lstName"),
    };
    AxiosFn.Post(`TimeAttendance/GetTableSaveStatus`, objParam, (result) => {
      setLoadingTable(false);
      setDataRow({
        ...p,
        arrRows: [...result.lstData],
        nDataLength: result.ObjTable?.nDataLength,
        nPageIndex: result.ObjTable?.nPageIndex,
      });
    });
  };

  const getFormInitial = () => {
    DialogFn.BlockUI();

    AxiosFn.Get(`TimeAttendance/GetFormInitial`, {}, (result) => {
      DialogFn.UnBlockUI();
      setArrName(result.lstNameActive);
    });
  };

  const handleSearch = () => {
    getTable(dataRow);
  };

  const handleClearFilter = () => {
    form.setValue("lstName", []);
    handleSearch();
  };

  useEffect(() => {
    GetMenuPermission(AxiosFn, setPermission, DialogFn);
    getFormInitial();
    getTable(dataRow);
  }, []);

  return (
    <FormProvider {...form}>
      <Grid container spacing={2}>
        <Grid item container justifyContent={"flex-end"} spacing={1}>
          <Grid item md={3} xs={12}>
            <MultipleSelectItem
              id={"selName"}
              name={"lstName"}
              label={`${I18n.SetText("TimeAttendance.sName")}`}
              options={arrName || []}
              disabled={!nPermission}
            />
          </Grid>
          <Grid item>
            <BtnClear
              id={"btnClearSearchAll"}
              IsCircleWithOutText={true}
              onClick={() => {
                handleClearFilter();
              }}
            />
          </Grid>
          <Grid item>
            <BtnSearch
              id={"btnSearch"}
              IsCircleWithOutText
              onClick={handleSearch}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <DataGrid
            sTableID={`tbSaveWorkingStatus`}
            columns={dataColumn}
            rows={dataRow}
            onLoadData={getTable}
            onDelete={handleDelete}
            isLoading={loadingTable}
            isHiddenToolHead={true}
            isShowCheckBox={nPermission}
            onRowSelectable={(p) => p.row.isCanDel}
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
}
